import { render, staticRenderFns } from "./AiGenArticleList.vue?vue&type=template&id=12dfdf68&scoped=true&"
import script from "./AiGenArticleList.vue?vue&type=script&lang=js&"
export * from "./AiGenArticleList.vue?vue&type=script&lang=js&"
import style0 from "./AiGenArticleList.vue?vue&type=style&index=0&id=12dfdf68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dfdf68",
  null
  
)

export default component.exports